export const DEFAULT_DENT = 14
// import {GAP_SIZE} from '../chart_helpers/AxisHelper'

export function dentedRect(w, h, dents, gapStart = null, dentSize = DEFAULT_DENT){
  // let r = Math.round(Math.max(2,Math.min(Math.min(w/10,h/10),8)))
  // console.log(Math.min(w/10,h/10),r)
  let r = Math.floor(Math.min(Math.min(w/3,h/3),dentSize))
  if(!Array.isArray(dents)) dents = [dents]
  let r_tl = dents.indexOf('tl')>=0?r:0
  let r_tr = dents.indexOf('tr')>=0?r:0
  let r_bl = dents.indexOf('bl')>=0?r:0
  let r_br = dents.indexOf('br')>=0?r:0
  
  let gapPath = ''
  if(gapStart){
    let dG,gH,ddG,gOffset
    
    if(h>w){
      dG = Math.min(w/2,gapStart-5)
      gH = Math.max(4,Math.min(6,dG/2))
      ddG = dG/2
      gOffset = gapStart - gH/2 - dG/2
      // gapPath = `M 0 ${gOffset} L ${w} ${gOffset} L ${w} ${gOffset+gH} L 0 ${gOffset+gH} L 0 ${gOffset}`
      gapPath = `M 0 ${gOffset} 
              c ${w/2-ddG-5} ${dG-ddG}, ${w/2+ddG} ${ddG}, ${w} ${dG}
              l 0 ${gH} 
              c ${-w/2+ddG+5} ${-dG+ddG}, ${-w/2-ddG} ${-ddG}, ${-w} ${-dG}
              l 0 -${gH}`
    } else {
      dG = Math.min(h/2,-gapStart+5)
      gH = Math.max(3,Math.min(6,dG/2))
      ddG = dG/2
      gOffset = w + gapStart + gH/2 + dG/2 
      // gapPath = `M ${gOffset} 0 L ${gOffset+gH} 0 L ${gOffset+gH} ${h} L ${gOffset} ${h} L ${gOffset} 0 `
      gapPath = `M ${gOffset} 0
              c ${-ddG} ${h/2-ddG-5}, ${-dG+ddG} ${h/2+ddG} , ${-dG} ${h}
              l ${-gH} 0 
              c ${ddG} ${-h/2+ddG+5}, ${+dG-ddG} ${-h/2-ddG} , ${dG} ${-h}
              l ${gH} 0 `
    }
    
  }
  
  
  return `M 0 ${r_tl} 
          v ${h-r_bl-r_tl}  a ${r_bl} ${r_bl} 1 0 0 ${r_bl}  ${r_bl}
          h ${w-r_bl-r_br}  a ${r_br} ${r_br} 1 0 0 ${r_br}  ${-r_br} 
          v ${-h+r_br+r_tr} a ${r_tr} ${r_tr} 1 0 0 ${-r_tr} ${-r_tr} 
          h ${-w+r_tr+r_tl} a ${r_tl} ${r_tl} 1 0 0 ${-r_tl} ${r_tl}`+
          gapPath
}